/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from "@angular/core";

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(RoleTypeDataService.Id, RoleTypeDataService);

    RoleTypeDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class RoleTypeDataService extends base.BaseDataService<Nema.Crew.Model.RoleType> implements IRoleTypeDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "roleTypeDataService";

    public get EntityName(): string {
        return "RoleType";
    }

    public get EntitiesName(): string {
        return "RoleTypes";
    }
}

export interface IRoleTypeDataService extends base.IDataService<Nema.Crew.Model.RoleType> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/jobroletypes.dataservice.ts